import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';

export default class ServidorRow extends Component {
  static propTypes = {
    servidor: PropTypes.object.isRequired,
    usaWebService: PropTypes.bool.isRequired
  };

  onViewDetalhes = item => {
    const entidadeOrigem = item.get('entidade') ? item.get('entidade') : 0;

    this.props.history.push(
      `/servidores/detalhes?vinculo=${item.get('vinculo')}&matricula=${item.get(
        'matricula'
      )}&entidadeOrigem=${entidadeOrigem}`
    );
  };

  render() {
    const { servidor, usaWebService } = this.props;
    const key = `${servidor.get('entidade')}_${servidor.get('matricula')}`;

    return (
      <TableActions
        ref="row"
        key={key}
        data={servidor}
        onMore={this.onViewDetalhes}
      >
        <td id="tableNome">{servidor.get('nome')}</td>
        <td id="tableMatricula">{servidor.get('matricula')}</td>
        <td id="tableSituacao">{servidor.get('situacao')}</td>
        {!usaWebService && (
          <td id="tableAdmissao">
            {DateUtils.formatDateTimeShort(servidor.get('dataAdmissao'))}
          </td>
        )}
        {!usaWebService && (
          <td id="tableDesligamento">
            {DateUtils.formatDateTimeShort(servidor.get('dataDemissao'))}
          </td>
        )}
        <td id="tableDescricaoCargo">{servidor.get('descricaoCargo')}</td>
        {!usaWebService && (
          <td id="tableHorasSemanais">{servidor.get('horasSemanais')}</td>
        )}
        {usaWebService && <td id="tableVinculo">{servidor.get('vinculo')}</td>}
        {!usaWebService && (
          <td id="tableDescricaoClasse">{servidor.get('descricaoClasse')}</td>
        )}
        {!usaWebService && (
          <td id="tableDescricaoNatureza">
            {servidor.get('descricaoNatureza')}
          </td>
        )}
        <td id="tableDescricaoLotacao">{servidor.get('descricaoLotacao')}</td>
      </TableActions>
    );
  }
}
